import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';

import styles from './styles.module.scss';

interface IProps {
  icon: IconDefinition;
  title: string;
  body?: string;
  /** A route link, or a button when the action happens on the page (`onClick`). */
  action?: { label: string; to?: string; onClick?: () => void };
  /** `inline` sits inside a card; `panel` is a standalone bordered block for a whole section. */
  variant?: 'inline' | 'panel';
}

/** One empty-state pattern for every hub section: icon, headline, a line of help, one action. */
export const AccountEmptyState = ({ icon, title, body, action, variant = 'inline' }: IProps): React.ReactElement => (
  <div className={variant === 'panel' ? `${styles.emptyState} ${styles.panel}` : styles.emptyState}>
    <span className={styles.iconWrap} aria-hidden="true">
      <FontAwesomeIcon icon={icon} />
    </span>
    <p className={styles.title}>{title}</p>
    {body ? <p className={styles.body}>{body}</p> : null}
    {action?.onClick ? (
      <button type="button" onClick={action.onClick} className={styles.action}>
        {action.label}
      </button>
    ) : action?.to ? (
      <Link to={action.to} className={styles.action}>
        {action.label}
      </Link>
    ) : null}
  </div>
);
